export default __webpack_public_path__ + "static/leak-indicator-08452db25072ba21e0d1aa939c24e915.png";